import { GraphResponse, TableResponse } from '../pages/dashBoardPage/interface';
import { get, getExcelDownload } from './apiService';

export const getAllGuestBymonth = async () => {
  return await get('/dashboard/guest-count-by-month');
};
export const getAllFacilitytBymonth = async () => {
  return await get('/dashboard/facilities-by-location');
};
export const getAllFacilityCountBymonth = async () => {
  return await get('/dashboard/facility-count-by-months');
};
export const getAllTotalCount = async () => {
  return await get('/dashboard/count-stats');
};
export const getAllTotalSupportBuisnessCount = async () => {
  return await get('/dashboard/supportBusiness-count-by-months');
};
export const getTotalBookings = async (params: any): Promise<GraphResponse> => {
  return await get('/toristy/dashboard/graph', params);
};
export const getDashboardTableData = async (
  params: any
): Promise<TableResponse> => {
  return await get('/toristy/dashboard/data', params);
};
export const getDownloadTableData = async (
  params: any
): Promise<TableResponse> => {
  return await getExcelDownload('/toristy/dashboard', params);
};
